export type TableV2Counts = {
  total: number;
  passed: number;
  failed: number;
  errored: number;
  skipped: number;
  untested: number;
};

export const formatTableV2StatusPercent = (count: number, total: number): string => {
  if (total <= 0) return '0%';
  const value = Math.round((count / total) * 1000) / 10;
  return Number.isInteger(value) ? `${String(value)}%` : `${value.toFixed(1)}%`;
};

export const formatTableV2PassRate = (counts: TableV2Counts): string =>
  counts.total > 0 ? formatTableV2StatusPercent(counts.passed, counts.total) : '-';
